import { render, staticRenderFns } from "./SysClientAccessLogList.vue?vue&type=template&id=40971e4f&scoped=true&"
import script from "./SysClientAccessLogList.vue?vue&type=script&lang=js&"
export * from "./SysClientAccessLogList.vue?vue&type=script&lang=js&"
import style0 from "./SysClientAccessLogList.vue?vue&type=style&index=0&id=40971e4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40971e4f",
  null
  
)

export default component.exports